import { useQuery } from '@tanstack/react-query';
import { getCustomerMetadata } from '@services/checkoutService';
import type { CustomerMetadata } from '@t/checkout.types';

const METADATA_STALE_TIME_MS = 1000 * 60 * 30;

export const useCustomerMetadata = () => {
  const { data, isLoading } = useQuery<CustomerMetadata>({
    queryKey: ['customerMetadata'],
    queryFn: getCustomerMetadata,
    staleTime: METADATA_STALE_TIME_MS,
  });

  return {
    metadata: data ?? null,
    isMetadataLoading: isLoading,
  };
};
